// extracted by mini-css-extract-plugin
export default {"imageWrapper":"bH-z","hovered":"cH-z","hoverImage":"dH-z","mainImage":"eH-z","imageNoBackground":"fH-z","fullSizeImage":"gH-z"};